import { createAction, props } from "@ngrx/store";
import { CardEnvironment } from "src/model/class/general classes/card-environment";
import { GenericApiData } from "src/components/shared-components/class/general-classes/generic-api-data";
import { CardEnvironmentStoreAction } from "src/components/shared-components/enum/enumStoreAction";

/**
 * Start load card environment action
 */
export const cardEnvironmentStartLoadAction = createAction(
  CardEnvironmentStoreAction.CARD_ENVIRONMENT_START_LOAD,
  props<{ idCard: number }>()
);

/**
 * Card environment load list success
 */
export const cardEnvironmentLoadSuccessAction = createAction(
  CardEnvironmentStoreAction.CARD_ENVIRONMENT_LOAD_SUCCES,
  props<{ listCardEnvironmentObject: GenericApiData }>()
);

/**
 * Start load card environment action
 */
export const cardEnvironmentLoadErrorAction = createAction(
  CardEnvironmentStoreAction.CARD_ENVIRONMENT_LOAD_ERROR
);

/**
 * Start switch active/disactive single card environment by id card and id environment
 */
export const cardEnvironmentStartSwithcActiveAction = createAction(
  CardEnvironmentStoreAction.CARD_ENVIRONMENT_SWITCH_ACTIVE_START,
  props<{ idCard: number; idEnvironment: number }>()
);

/**
 * Success switch active/disactive single card environment
 */
export const cardEnvironmentSwithcActiveSuccessAction = createAction(
  CardEnvironmentStoreAction.CARD_ENVIRONMENT_SWITCH_ACTIVE_SUCCES,
  props<{ cardEnvironment: CardEnvironment }>()
);

/**
 * Error switch active/disactive single card environment
 */
export const cardEnvironmentSwithcActiveErrorAction = createAction(
  CardEnvironmentStoreAction.CARD_ENVIRONMENT_SWITCH_ACTIVE_ERROR
);

/**
 * Start assign timeslot  by id card environment
 */
export const cardEnvironmentAssignTimeSlotAction = createAction(
  CardEnvironmentStoreAction.CARD_ENVIRONMENT_ASSIGN_TIMESLOT_START,
  props<{ cardEnvironment: CardEnvironment; idTimeSlot: number }>()
);

/**
 * Start assign cardEnvironment  by id card environment
 */
export const cardEnvironmentAssignCalendarAction = createAction(
  CardEnvironmentStoreAction.CARD_ENVIRONMENT_ASSIGN_CALENDAR_START,
  props<{ cardEnvironment: CardEnvironment; idCalendar: number }>()
);
